// ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const dict = {
    en: {
        loading: "Loading...",
        checking: "Checking your session, please wait.",
    },
    ru: {
        loading: "Загрузка...",
        checking: "Проверяем вашу сессию, пожалуйста подождите.",
    },
    ua: {
        loading: "Завантаження...",
        checking: "Перевіряємо вашу сесію, зачекайте.",
    },
};

const getInitialLang = () => (localStorage.getItem("lang") || "en").toLowerCase();

const PUBLIC_PATHS = new Set([
    "/",
    "/sign-in",
    "/sign-up",
    "/forgot-password",
    "/validate-two-fa",
    "/choose-workspace",
    "/waiting-approval",
]);

const ProtectedRoute = ({ children, allowAccessRequired = true }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    const lang = getInitialLang();
    const t = dict[lang] || dict.en;

    if (loading) {
        return (
            <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "rgba(15, 23, 42, 0.35)", zIndex: 2000 }}
            >
                <div className="card border-0 shadow-lg rounded-4 p-4 text-center" style={{ minWidth: 280 }}>
                    <div className="spinner-border text-primary mb-3" role="status" />
                    <h5 className="mb-1">{t.loading}</h5>
                    <div className="text-muted small">{t.checking}</div>
                </div>
            </div>
        );
    }

    // не залогинен
    if (!user) {
        return <Navigate to="/sign-in" replace state={{ from: location }} />;
    }

    // публичные роуты всегда разрешены
    if (!allowAccessRequired || PUBLIC_PATHS.has(location.pathname)) {
        return children;
    }

    // залогинен, но доступ не выдан -> ведём на 2FA/ожидание
    if (user.allow_access === false) {
        const target = "/validate-two-fa"; // или "/waiting-approval"
        if (location.pathname !== target) {
            return <Navigate to={target} replace state={{ from: location }} />;
        }
        return children; // если уже на целевой странице, не зацикливаем
    }

    // корень -> на дашборд
    if (location.pathname === "/") {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
